/* eslint-disable react-hooks/exhaustive-deps */
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, Card, FormControl, Grid, IconButton, InputLabel, MenuItem, Modal, Select, TextField, Typography } from "@mui/material";
import { Editor } from "@tinymce/tinymce-react";
import Button from "components/Button/button";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import tinymce from "tinymce";
import { addInvoiceReminderData, fetchInvoiceReminderById, getLegalDocumets, updateInvoiceReminder } from "utils/api";
import { appConstants } from "utils/appConstants";
import { generateDataList, getScreenRight, showResMsg, validateField } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import PageTitle from "examples/PageTitle/PageTitle";
import { getColorMappings } from "components/ColorComponent/ColorComponent";

const { default: DashboardLayout } = require("examples/LayoutContainers/DashboardLayout");

const errMsg = {
  color: `red`,
  fontSize: `11px`,
};
const pdfStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%", // increase the width
  height: "90%x", // increase the height
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
let routePath = "/invoiceReminderTemplate";

function AddInvoiceReminderTemplate(addProps) {
  const { id } = useParams();
  const remarksFieldRef = useRef(null);
  const [controller] = useMaterialUIController();
  const navigate = useNavigate();
  const { darkMode, sidenavColor } = controller;
  const dispatch = useDispatch();
  const [screenName, setScreenName] = useState("Add Invoice Reminder Template");
  const [tName, setTName] = useState(false);
  const [tSubject, setTSubject] = useState(false);
  const [tMessage, setTMessage] = useState(false);
  const [rDays, setRDays] = useState(false);
  const [inputStatus, setInputStatus] = useState(false);
  const [disableColor, setDisableColor] = useState(false);
  const [legalDocumentFormats, setlegalDocumentFormats] = useState([]);
  const [legalDocumentDetails, setLegalDocumentDetails] = useState([]);
  const [viewDocumentInModal, setViewDocumentInModal] = useState(false);
  const [getDocumentFileURL, setSetDocumentFileURL] = useState('');
  const [values, setValues] = React.useState({
    Status: "Active",
    _id: "",
    reminderTemplateName: "",
    emailSubject: "",
    emailBody: "",
    reminderType: "Due In",
    reminderDays: "",
    legalDocumentID: "None",
    legalDocumentRemarks: "",
    documentFileName: "",
    businessUserID: JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'))?.businessUserID,
  });
  values._id = id;

  const editorRef = useRef(null);

  useEffect(() => {
    tinymce.init({
      selector: '#mytextarea',
      readonly: false
    });
  }, []);

  useEffect(() => {
    id === undefined ? setScreenName("Add Invoice Reminder Template") : setScreenName("Email Body");
    (async () => {
      await Promise.all([
        getRight(),
        fetchData()
      ]);
      fetchDataByID()
    }
    )();
  }, [dispatch]);


  async function fetchData() {
    getLegalDocumets({ businessUserID: values.businessUserID }, async (data) => {
      if (data.Result_Output.length > 0) {
        setLegalDocumentDetails(data.Result_Output);
        setlegalDocumentFormats(await generateDataList(data.Result_Output, "_id", "documentName"));
      }

    }, dispatch)
  }
  const updateValues = (newData) => {
    setValues((prevValues) => ({
      ...prevValues,
      ...newData,
    }));
  };
  async function fetchDataByID() {
    if (id !== undefined) {
      values._id = id;
      setInputStatus(true);
      fetchInvoiceReminderById(values, (data) => {
        console.log("data.Result_Output[0]", data.Result_Output[0]);
        if (!data.Result_Output[0].legalDocumentID) {
          data.Result_Output[0].legalDocumentID = "None"
        }
        updateValues(data.Result_Output[0]);
      }, dispatch)
    }
  }
  useEffect(() => {
    if (remarksFieldRef.current) { remarksFieldRef.current.focus(); }
  }, [values.legalDocumentID])

  async function getRight() {
    let right = await getScreenRight("InvoiceReminderTemplates")
    if (right === "Full Access") {
      setDisableColor(false)
    }
    else setDisableColor(true)
  }
  const handleChange = (name) => (event) => {
    let inputValue = event.target.value;
    if (event.target.validity && event.target.validity.valid) {
      setValues({ ...values, [name]: inputValue });
    }
    else if (event.target.validity === undefined) {
      if (name === 'legalDocumentID') {
        if (inputValue !== "None") {

          const document = legalDocumentDetails.find(doc => doc._id === inputValue);
          setValues({ ...values, [name]: inputValue, documentFileName: document ? document.documentFileName : "" });

        } else {
          setValues({ ...values, [name]: inputValue, legalDocumentRemarks: "" });
        }
      } else if (name === 'reminderType') {
        setValues({ ...values, [name]: inputValue, legalDocumentRemarks: "", legalDocumentID: "None", });
      } else {
        setValues({ ...values, [name]: inputValue });
      }
    }
  };


  const clearErrorStates = () => {
    setTName(false);
    setTSubject(false);
    setTMessage(false);
    setRDays(false);
  };

  const addInvoiceReminder = async () => {
    let mandateFlag = false;
    clearErrorStates();
    mandateFlag = validateField(values.reminderTemplateName, setTName) || mandateFlag;
    mandateFlag = validateField(values.emailSubject, setTSubject) || mandateFlag;
    mandateFlag = validateField(values.emailBody, setTMessage) || mandateFlag;
    mandateFlag = validateField(values.reminderDays, setRDays) || mandateFlag;

    if (mandateFlag) {
      return;
    }
    // if (values.legalDocumentID === "None") {
    //   values.legalDocumentID = undefined;
    // }
    console.log('values', values)
    const apiFunction = id === undefined ? addInvoiceReminderData : updateInvoiceReminder;
    apiFunction(values, (data) => {

      if (data.Result_Status) {
        showResMsg(id === undefined ? genericMessage.added : genericMessage.updated, 1000, data.Result_Status, navigate, routePath);
      } else {
        showResMsg(data.Result_Message, 2000, data.Result_Status);
      }
    }, dispatch);
  };

  const handleViewDocument = () => {
    if (values.documentFileName) {

      setSetDocumentFileURL(appConstants.baseURL + 'invoiceReminderLogs/viewSentLegalDocument?fileName=/' + values.documentFileName);
      setViewDocumentInModal(true);
    } else {
      showResMsg("Please select document first", 2000, false);
      setViewDocumentInModal(false);

    }
  };


  var dropicons = document.querySelectorAll('.MuiInputBase-root');
  for (let i = 0; i < dropicons.length; i++) {
    var svgicon = dropicons[i].getElementsByTagName('svg');
    if (svgicon.length > 0) {
      if (darkMode) {
        svgicon[0].setAttribute("style", "fill: white !important;");
      } else {
        svgicon[0].setAttribute("style", "fill:");
      }
    }
  }



  var disablefields = document.querySelectorAll(".Mui-disabled");
  for (let i = 0; i < disablefields.length; i++) {
    var disabled = disablefields[i].getElementsByClassName('MuiInputBase-input');
    if (disabled.length > 0 && disabled[0]) {
      if (darkMode) {
        disabled[0].style.opacity = "1";
      }
    }
  }


  const { tableBorder } = getColorMappings(sidenavColor);
  var element = document.getElementsByTagName('fieldset');

  useEffect(() => {

    var labeltext = document.querySelectorAll('.MuiTextField-root label');
    var usevalue = document.querySelectorAll('.MuiTextField-root input');
    var svgIcons = document.querySelectorAll('.MuiInputBase-root svg');

    for (let i = 0; i < element.length; i++) {
      if (darkMode) {
        element[i].style.borderColor = "white";


      } else {
        element[i].style.borderColor = tableBorder;


      }
    }

    labeltext.forEach(labeltxt => {
      if (darkMode) {
        labeltxt.style.color = "white";
      } else {
        labeltxt.style.color = "#1A73E8";
      }
    });

    usevalue.forEach(inputtxt => {
      if (darkMode) {
        inputtxt.style.setProperty("-webkit-text-fill-color", "white", "important");
        inputtxt.style.setProperty("opacity", "0.7", "important")
      } else {
        inputtxt.style.removeProperty("-webkit-text-fill-color");
      }
    });



    svgIcons.forEach(icon => {
      if (darkMode) {
        icon.setAttribute("style", "fill: white !important;");
      } else {
        icon.removeAttribute("style");
      }
    });
  }, [darkMode, values.legalDocumentID]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ marginTop: "20px" }}>
        <Card sx={{ boxShadow: "none" }}>
          <PageTitle screenName={screenName} />
          <MDBox mt={1.6} mb={3}>
            <Grid container spacing={1} style={{ display: "flex", justifyContent: "center" }}>
              <Grid item lg={12} xs={12}>

                <Grid
                  container
                  // p={2.2}
                  px={2.2}
                  columnSpacing={{ xs: 2, sm: 2, md: 3, lg: 3 }}
                  rowSpacing={{ xs: 2, sm: 2, md: 3, lg: 3 }}
                >
                  <Grid item lg={12} xs={12}>
                    <TextField
                      type="text"
                      label="Reminder Template Name"
                      variant="outlined"
                      fullWidth
                      placeholder="Reminder Template Name"
                      value={values.reminderTemplateName}
                      onChange={handleChange("reminderTemplateName")}
                      inputProps={{
                        pattern: "^[a-zA-Z0-9!@#$%^&*()_+=-{};:'<>,./?]+$",
                        maxLength: 60,
                        className: "custom-fieldtext"
                      }}
                      disabled={inputStatus}
                      autoFocus={true}
                    />
                    {tName ? <span style={errMsg}>Reminder Template Name can't be blank</span> : ""}
                  </Grid>
                  <Grid item lg={2} xs={12}>
                    <FormControl fullWidth>
                      <InputLabel id="reminder-type"> Reminder Type </InputLabel>
                      <Select
                        labelId="reminder-type"
                        id="select-reminder-type"
                        style={{ minHeight: "35.11px" }}
                        label="Reminder Type"
                        value={values.reminderType}
                        onChange={handleChange("reminderType")}
                      // disabled={inputStatus}
                      >
                        <MenuItem value="Overdue By">Overdue By</MenuItem>
                        <MenuItem value="Due In">Due In</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item lg={2} xs={12}>


                    <TextField
                      type="text"
                      label={values.reminderType === "Due In" ? "Due In Days " : "Overdue By Days "}
                      variant="outlined"
                      fullWidthfd cv
                      placeholder="No. of Days"
                      value={values.reminderDays}
                      onChange={handleChange("reminderDays")}
                      inputProps={{
                        pattern: "^[0-9]+$",
                        maxLength: 10,
                        className: "custom-fieldtext"
                      }}

                    />
                    {rDays ? <span style={errMsg}>Reminder Days can't be blank</span> : ""}
                  </Grid>

                  <Grid item lg={2.6} xs={12}>
                    <FormControl fullWidth>
                      <InputLabel id="legal-document">Select Legal Document</InputLabel>
                      <Select
                        labelId="legal-document"
                        id="select-legal-document"
                        style={{ minHeight: "35.11px" }}
                        label="Select Legal Document"
                        value={values.legalDocumentID}
                        disabled={values.reminderType === "Due In"}
                        onChange={handleChange("legalDocumentID")}
                      >
                        <MenuItem value="None">None</MenuItem>
                        {legalDocumentFormats}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item lg={0.4} pt={0.5}>
                    <IconButton style={{ marginLeft: "-20px", marginTop: "-6px" }}>
                      {values.legalDocumentID !== "None" ?
                        <Visibility fontSize="large" color="info" onClick={handleViewDocument} />
                        :
                        <VisibilityOff fontSize="large" color="grey" />
                      }
                    </IconButton>
                  </Grid>

                  <Grid item lg={4} xs={12}>
                    <FormControl fullWidth>
                      <InputLabel id="template-status"> Status</InputLabel>
                      <Select
                        labelId="template-status"
                        id="select-template-status"
                        style={{ minHeight: "35.11px" }}
                        label=" Status"
                        value={values.Status}
                        onChange={handleChange("Status")}

                      >
                        <MenuItem value="Active">Active</MenuItem>
                        <MenuItem value="Inactive">Inactive</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  {values.legalDocumentID !== "None" &&
                    <Grid item lg={12} xs={12}>
                      <TextField
                        type="text"
                        variant="outlined"
                        fullWidth
                        autoFocus
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ maxLength: 300, className: "custom-fieldtext" }}
                        label="Legal Document Remarks"
                        value={values.legalDocumentID !== "None" ? values.legalDocumentRemarks : ""}
                        onChange={handleChange("legalDocumentRemarks")}
                        inputRef={remarksFieldRef}
                      />
                    </Grid>}

                  <Grid item lg={12} xs={12}>
                    <TextField
                      type="text"
                      label="Email Subject"
                      variant="outlined"
                      fullWidth
                      value={values.emailSubject}
                      InputLabelProps={{ shrink: true }}
                      onChange={handleChange("emailSubject")}
                      inputProps={{
                        maxLength: 200,
                        className: "custom-fieldtext"

                      }}
                    />
                    {tSubject ? <span style={errMsg}>Email Subject can't be blank</span> : ""}
                  </Grid>

                  <Grid item lg={12} xs={12}>
                    <MDTypography type="label" size={14} >
                      Email Body
                    </MDTypography>
                    <div className={`editor-container ${darkMode ? 'dark-modes' : 'light-modes'}`}>
                      <Editor
                        apiKey="your-api-key"
                        maxLength="5000"
                        onEditorChange={(newText) => (values.emailBody = newText)}
                        onInit={(evt, editor) => (editorRef.current = editor)}
                        initialValue={values.emailBody}


                        // initialValue={values.finalEmailBody}
                        init={{
                          height: 271,
                          menubar: true,
                          selector: 'textarea',

                          plugins: [
                            "advlist autolink lists link image charmap print preview anchor",
                            "searchreplace visualblocks code fullscreen",
                            "insertdatetime media table paste code help wordcount attachment",
                          ],
                          toolbar:
                            "undo redo | formatselect | " +
                            "bold italic backcolor | alignleft aligncenter " +
                            "alignright alignjustify | bullist numlist outdent indent | link attachment " +
                            "removeformat | help",

                          content_style:
                            "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                        }}
                      />
                    </div>
                    {tMessage ? <span style={errMsg}> Email Body can't be blank</span> : ""}
                  </Grid>

                </Grid>
                {/* </Card> */}
              </Grid>
            </Grid>
            <Grid container mt={2}
              // columnSpacing={{ xs: 2, md: 4, lg: 5 }}
              spacing={2}
              style={{ display: "flex", justifyContent: "center" }}
              alignItems="center">
              <Grid item xs={12} md={4} spacing={2} lg={1.701}  >
                <Link to={"/invoiceReminderTemplate"}>
                  <Button color="warning" fullWidth style={{ height: "40px" }}>Close</Button>
                </Link>
              </Grid>
              <Grid item xs={12} md={4} spacing={2} lg={1.701}>

                <Button
                  rel="noreferrer"
                  variant="gradient"
                  className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                  color={disableColor ? "success" : "secondary"}
                  fullWidth
                  // onClick={disableColor ? blank : addInvoiceReminder}
                  onClick={addInvoiceReminder}
                  style={{ height: "40px" }}
                >
                  {id !== undefined ? <>Update</> : <>Save</>}

                </Button>
              </Grid>
            </Grid>
          </MDBox>


          <Modal
            open={viewDocumentInModal}
            onClose={() => setViewDocumentInModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={{
              '& .MuiModal-root': {
                width: '100%',
                height: '100%',
              },
            }}
          >
            <Card sx={pdfStyle}>
              <Box>
                <Typography
                  id="modal-modal-title"
                  variant="h6"
                  component="h2"
                >
                  Quotation Document Viewer
                </Typography>
                <iframe title="Quotation Document Viewer" src={getDocumentFileURL} width="100%" height="650" frameborder="0" allowfullscreen={true}></iframe>

                <Grid container id="modal-modal-description" sx={{ mt: 2, justifyContent: "center" }}>
                  <MDButton color="warning" className="modalButton" onClick={() => { setViewDocumentInModal(false) }}>

                    Close
                  </MDButton>
                </Grid>
              </Box>
            </Card>
          </Modal>
        </Card>
      </div>
    </DashboardLayout>
  );
}

export default AddInvoiceReminderTemplate;
